import './blogCarousel.scss';

import React, { forwardRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Card, Typography, Carousel } from '../base';
import CloudinaryPicture from './cloudinaryPicture';
import useWindowSize from '../hooks/useWindowSize';

const BlogCarousel = forwardRef((props, ref) => {
  const totalSlides = React.Children.count(props.children);
  const [visibleSlides, setVisibleSlides] = useState(1);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    setVisibleSlides(isMobile ? 1 : 3);
  }, [isMobile]);

  return (
    <Carousel
      ref={ref}
      className={props.className}
      totalSlides={totalSlides}
      visibleSlides={visibleSlides}
      isPlaying
      infinite
    >
      <Carousel.Slider>{props.children}</Carousel.Slider>
      <Carousel.DotGroup />
    </Carousel>
  );
});

BlogCarousel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const BlogCarouselItem = forwardRef((props, ref) => {
  const className = classNames({
    item: true,
    [props.className]: props.className,
  });

  return (
    <Carousel.Slide ref={ref} index={props.index} className={className}>
      <Card asLink href={props.url} targetBlank>
        <div className="card-img-top">
          <CloudinaryPicture imageKey={props.imageKey} />
        </div>
        <Card.Body>
          <Typography.H4>
            <span>{props.title}</span>
          </Typography.H4>
          {props.children}
        </Card.Body>
      </Card>
    </Carousel.Slide>
  );
});

BlogCarouselItem.propTypes = {
  index: PropTypes.number,
  imageKey: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

BlogCarousel.Item = BlogCarouselItem;

export default BlogCarousel;
